import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { AmplitudeEvent } from 'utils/amplitude/amplitudeEvents'
import { useRewardsSheetContext } from '../context/RewardsSheetProvider'
import useRewardsTracking from '../hooks/useRewardsTracking'
import { RewardsActionIds } from '../types'
import { formatAPY } from '../utils'
import { RewardsAsset } from './RewardsAsset'

interface RewardsAssetsProps {
  title: string
}

export const RewardsAssets = ({ title }: RewardsAssetsProps) => {
  const { t } = useTranslation()
  const { trackClick } = useRewardsTracking()
  const { handleSheetOpen, rewardsProducts } = useRewardsSheetContext()

  const handleDeposit = (currency: string) => {
    trackClick(AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_INITIATE)
    handleSheetOpen({
      actionId: RewardsActionIds.DEPOSIT,
      header: t('rewards.deposit.header'),
      selectedCurrency: currency,
    })
  }

  return (
    <Box flexCol gapY={16}>
      <h4 className="text-h4 text-foreground-prominent">{title}</h4>
      <Box flexCol gap={16} className="lg:flex-row">
        {rewardsProducts?.map(product => (
          <RewardsAsset
            key={product?.currency}
            currency={product?.currency}
            apyRate={formatAPY(product?.earningRate)}
            onDeposit={() => handleDeposit(product?.currency)}
          />
        ))}
      </Box>
    </Box>
  )
}
